export default __webpack_public_path__ + "static/media/ic_next_arrow.f85e5201.svg";